var alignment_rtlignore_default = {
  "alignLeft": "_6kaZH",
  "textWrapNowrap": "_22FKO",
  "alignRight": "NSPAS",
  "alignCenter": "D9ROV",
  "sizeFullWidth": "vV9mh",
  "renderedInTable": "_61BUX",
  "sizeOriginal": "_7u--P",
  "sizeContent": "_6ygWX",
  "sizeSmall": "a24q4",
  "sizeSmallCenter": "ySQq8",
  "flex": "dKwDy",
  "LEFT": "rbk55",
  "CENTER": "_3StRD",
  "RIGHT": "_408wu",
  "AUTO": "mcSBi",
  "JUSTIFY": "vamab"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
